import React, { useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { About } from "@/components/About";
import { SimpleContactForm } from "@/components/SimpleContactForm";
import { DetailedForm } from "@/components/DetailedForm";
import { Testimonials } from "@/components/Testimonials";
import { Footer } from "@/components/Footer";
import AdminPage from "@/pages/AdminPage";

function LandingPage() {
  const contactRef = useRef(null);
  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <Header onContactClick={scrollToContact} />
      <main>
        <Hero onCTAClick={scrollToContact} />
        <Services />
        <About />
        <div ref={contactRef}>
          <SimpleContactForm />
        </div>
        <DetailedForm />
        <Testimonials />
      </main>
      <Footer onContactClick={scrollToContact} />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
